import React from 'react';
import { ShoppingCartIcon, LeafIcon, SparklesIcon } from 'lucide-react';
export function Header() {
  return <header className="bg-gradient-to-r from-green-50 via-white to-green-50 py-4 shadow-md sticky top-0 z-50 border-b border-green-100" data-id="element-95">
      {/* Google Font Import */}
      <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-96" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" data-id="element-97" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" data-id="element-98" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="flex justify-between items-center" data-id="element-100">
          <div className="flex-shrink-0 flex items-center" data-id="element-101">
            <LeafIcon className="h-7 w-7 text-green-600 mr-2 animate-pulse" data-id="element-102" />
            <h1 className="text-xl font-bold bg-gradient-to-r from-green-700 to-green-500 bg-clip-text text-transparent" data-id="element-103">
              KIT DE EMERGENCIA ANTI-ESTRÉS
            </h1>
          </div>
          <div className="flex items-center space-x-4" data-id="element-104">
            <div className="hidden md:flex items-center text-sm text-green-700 font-medium" data-id="element-105">
              <SparklesIcon className="h-4 w-4 mr-1" data-id="element-106" />
              <span data-id="element-107">¡5 Bonos Gratis!</span>
            </div>
            <a href="https://clickylee.com/products/kit-de-emergencias-anti-stress-5-bonos-gratis?variant=46954999415019" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" data-id="element-108">
              <ShoppingCartIcon className="h-4 w-4 mr-2" data-id="element-109" />
              <span data-id="element-110">Descargar por ARS $19.997</span>
            </a>
          </div>
        </div>
      </div>
      {/* Mobile price banner */}
      <div className="md:hidden mt-2 bg-amber-50 py-1.5 text-center text-xs font-medium text-amber-800" data-id="element-111">
        <SparklesIcon className="h-3 w-3 inline-block mr-1" data-id="element-112" />
        Oferta especial: ARS $19.997 con 5 bonos gratis
      </div>
    </header>;
}